// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import PromiseUtil from "../../../../../engines/libs/PromiseUtil";
import utilsModel from "../../../../../engines/libs/utilsModel";
import { FileKind } from "../../../../define/FileKind";
import { GeneralKind } from "../../../../define/GeneralKind";
import SettleLawsuitPrimaryExhibitItem from "./SettleLawsuitPrimaryExhibitItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitPrimaryStepSelect extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	sprGoodsBg: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	sprSelectBg: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	goodsLayout: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeGoods: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeBtn: cc.Node = null;

    @property(cc.Prefab)
    goodsPrefab: cc.Prefab = null;

    private spaceY = 0;
    private goodsSpaceX = 0;

    start () {
        this.spaceY = this.sprSelectBg.height - this.nodeBtn.height;
        this.goodsSpaceX = this.sprGoodsBg.width - this.goodsLayout.width;
        this.initLayer();
    }

    initLayer() {
        this.showSelect();
        this.showGoods();
    }

    showSelect() {
        let select = this._carryData.select;
        let is_show_btn = this._carryData.is_show_btn;
        let lookExhibitList = this._carryData.lookExhibitList;

        this.nodeBtn.children.forEach((v)=> {
            v.active = false;
        });

        let btnItem = this.nodeBtn.children[1];
        let selectArr = utilsModel.splitLineFeed(select);
        let showList: string[] = [];
        if (utilsModel.isValidNumberValue(is_show_btn)) {
            showList = utilsModel.splitLineFeed(is_show_btn);
        }

        let idx = 0;
        for (let i = 0; i < selectArr.length; i++ ) {
            let o = selectArr[i];
            if (showList[i]) {
                let splitsE = showList[i].split(FileKind.ResParseType.SUB_ITEM);
                if (splitsE[0] == GeneralKind.ValueChangeType.OWN_EXHIBIT) {
                    if (!lookExhibitList.includes(splitsE[1])) {
                        continue;
                    }
                }
            }

            let nodeSel = this.nodeBtn.children[idx];
            if (!nodeSel) {
                nodeSel = cc.instantiate(btnItem);
                this.nodeBtn.addChild(nodeSel);
            }
            nodeSel.active = true;

            nodeSel.getComponent(cc.Button).clickEvents[0].customEventData = '' + i;
            
            let label = cc.find('label', nodeSel).getComponent(cc.Label);
            label.string = o;

            idx++;
        }
        this.nodeBtn.getComponent(cc.Layout).updateLayout();
        this.sprSelectBg.height = this.nodeBtn.height + this.spaceY;
    }

    showGoods() {
        this.nodeGoods.active = false;
        let exhibit = this._carryData.exhibit;
        if (!utilsModel.isValidNumberValue(exhibit)) {
            return;
        }
        
        this.nodeGoods.active = true;
        let petitioner = this._carryData.petitioner;
        if (petitioner == 0) {
            
            
        } else {
            this.goodsLayout.anchorX = 1;
            this.sprGoodsBg.scaleX = -1;
            this.sprGoodsBg.x += this.sprGoodsBg.width;
            this.goodsLayout.x += this.goodsLayout.width;
        }
        let exhibitArr = utilsModel.splitLineFeed(exhibit);
        for (let i = 0; i < exhibitArr.length; i++ ) { 
            let goodsId = exhibitArr[i];
            if (goodsId.trim() == '') {
                continue;
            }
            let goodsItem = cc.instantiate(this.goodsPrefab);
            let script = goodsItem.getComponent(SettleLawsuitPrimaryExhibitItem);
            script.setCarryData({
                goodsId: goodsId
            });
            this.goodsLayout.addChild(goodsItem);
        }

        this.nodeGoods.x = this._carryData.peoplePos.x - cc.winSize.width/2;
        this.goodsLayout.getComponent(cc.Layout).updateLayout();
        this.sprGoodsBg.width = this.goodsLayout.width + this.goodsSpaceX;
    }

    onClickSelect(event: cc.Event.EventTouch, data) {
        let idx = Number(data);
        this.destroyNode();
        let relevancy_id = this._carryData.relevancy_id;
        let splits = utilsModel.splitLineFeed(relevancy_id);
        this._carryData.parent.nextStep(splits[idx]);
    }

    // update (dt) {}
}
